import React, { ReactElement } from 'react';

const PatientRedirect = (): ReactElement => {
    return (
        <div className="flex-centering">
            <h4>Login with the link that is shared to you</h4>
        </div>
    );
};

export default PatientRedirect;
